"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZonePrompt = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PromptDismissible_1 = require("Common/Prompt/PromptDismissible");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var Types_1 = require("SettingsAngular/Reports/Types");
var styles = __importStar(require("./TimeZonePrompt.css"));
var TimeZonePrompt = function (props) {
    return (react_1.default.createElement(PromptDismissible_1.PromptDismissible, { promptId: PromptTypes_1.PromptId.AnalyticsTimeZone },
        react_1.default.createElement(Prompt, __assign({}, props))));
};
exports.TimeZonePrompt = TimeZonePrompt;
var Prompt = function (_a) {
    var timeZone = _a.timeZone, isAdmin = _a.isAdmin, onDismiss = _a.onDismiss, closeModal = _a.closeModal;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.timeZonePrompt },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", padding: "xs" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
                react_1.default.createElement(icons_1.Clock, { color: "caution" }),
                react_1.default.createElement(kaleidoscope_1.Text, { className: styles.cautionText, strong: true, lineHeight: "compact" },
                    "Time zones are displayed in ",
                    timeZone,
                    " time")),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "l" },
                isAdmin && (react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/reporting#".concat(Types_1.AnalyticsSettingSectionId.Timezone), onClick: closeModal }, "Manage account time zone")),
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: onDismiss ? function () { return onDismiss(); } : undefined, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "Got it")))));
};
